import React, { Component, useRef, useState, useLayoutEffect } from 'react';
import Select from "react-select";
import chroma from "chroma-js";
import COLORS from "scss/colors.module.scss";
import { Chip, Tooltip } from "@material-ui/core";
import tinycolor from "tinycolor2";
import ApiClient from "utils/ApiClient";
import ColorsSet from "app/common/utils/ColorsSet";

var count = 0; // no of times the editor is called from renderer
export default class DropDownColumnEditor extends Component {
  constructor(props) {
    super(props);
    var options = [{
      value: "",
      label: "",
      color: COLORS.PRIMARY_COLOR,
      background: "transparent",
    }];
    var columnOptions = props.colDef?.cellRendererParams?.columnOptions;
      columnOptions?.options?.map((option, index) => {
      let luminance = tinycolor(columnOptions.colors?.[index]).getLuminance();
      options.push({
        value: option,
        label: option,
        color: 
          luminance > 0.5
            ? tinycolor(columnOptions.colors[index]).darken(60).toString()
            : COLORS.PRIMARY_COLOR,
        background: columnOptions.colors?.[index] || "grey",
      });
      return 0;
    });
    this.inputValue = props.charPress ? props.charPress : "";
    this.newOptionColor = ColorsSet[Math.floor(Math.random() * ColorsSet.length)];
    const isNewOption = !columnOptions.options.includes(this.inputValue);
    const isAdmin = window.appStore.containerStore.listConfig.listPermissions.is_admin == "1";

    if (isNewOption && this.inputValue.trim() !== "" && (isAdmin || columnOptions.is_allow_non_admin === true)) {
      const luminance = tinycolor(this.newOptionColor).getLuminance();
      options.push({
        value: this.inputValue,
        label: `Add option: ${this.inputValue}`,
        color: luminance > 0.5
          ? tinycolor(this.newOptionColor).darken(60).toString()
          : COLORS.PRIMARY_COLOR,
        background: this.newOptionColor,
      });
    }

    this.state = {
      options: options,
      selectedOption: !props.value
        ? null
        : options.find((option) => option.label === props.value),
      top: false,
      bottom: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  focusNextCell = () => {
    this.props.api.setFocusedCell(this.props.rowIndex, this.props.column.colId);
  };

  handleChange = async (selectedOption, shouldStopEditing = false) => {
    if (selectedOption) {
      if (typeof selectedOption.label === 'string' && selectedOption.label.startsWith("Add option")) {
        const { value } = selectedOption;
        const isAdmin = window.appStore.containerStore.listConfig.listPermissions.is_admin == "1";
        const columnOptions = this.props.colDef?.cellRendererParams?.columnOptions;
        const isNewOption = !columnOptions.options.includes(value);
        if (isNewOption && value.trim() !== "" && (isAdmin || columnOptions.is_allow_non_admin === true)) {
          columnOptions.options.push(value);
          columnOptions.colors.push(selectedOption.background);
  
          const { listId, columnId } = this.props.colDef?.cellRendererParams;
          try {
            const resp = await ApiClient.List.addDropdownOption({
              list_id: listId,
              data: JSON.stringify([columnOptions]),
              columnId: columnId
            });

            const subsheetColumnId = this.props.colDef.store.parentColumnId ?? 0;
  
            if (resp?.data?.result?.column) {
              this.props.onChange(value);
              if(!this.props.colDef.store.addColumnStore.onColumnConfigChange) {
                this.props.colDef.store.containerStore.addDropdownOption(resp?.data?.result?.column);
              } else {
                window.appStore.containerStore.handleSubsheetAddDropdownOption(resp?.data?.result?.column, subsheetColumnId);
              }
              if (shouldStopEditing) {
                this.props.api.stopEditing();
              }
            }
          } catch (e) {
            console.log("Error block", e);
          }
        }
      } else {
        this.props.onChange(selectedOption.value);
        this.setState({ selectedOption }, () => {
          if (shouldStopEditing) {
            this.props.api.stopEditing();
            this.focusNextCell();
          }
        });
      }
    }
  };
  

  handleInputChange = (inputVal) => {
    const isAdmin = window.appStore.containerStore.listConfig.listPermissions.is_admin == "1";
    this.inputValue = inputVal;
    const options = [];
    const columnOptions = this.props.colDef?.cellRendererParams?.columnOptions;
    columnOptions?.options?.forEach((option, index) => {
      let luminance = tinycolor(columnOptions.colors?.[index]).getLuminance();
      options.push({
        value: option,
        label: option,
        color: luminance > 0.5
          ? tinycolor(columnOptions.colors[index]).darken(60).toString()
          : COLORS.PRIMARY_COLOR,
        background: columnOptions.colors?.[index] || "grey",
      });
    });

  const isNewOption = !columnOptions.options.includes(inputVal);

  if (isNewOption && inputVal.trim() !== "" && (isAdmin || columnOptions.is_allow_non_admin === true)) {
    const luminance = tinycolor(this.newOptionColor).getLuminance();
    options.push({
      value: inputVal,
      label: `Add option: ${inputVal}`,
      color: luminance > 0.5
        ? tinycolor(this.newOptionColor).darken(60).toString()
        : COLORS.PRIMARY_COLOR,
      background: this.newOptionColor
    });
    
  }
  this.setState({ options });

};


  componentDidMount() {
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  componentWillMount(){
    count = count + 1;   // if the editor is called twice, the  editing is stopped
    if (count == 2) {
      this.props.api.stopEditing();
    }
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    document.removeEventListener("mousedown", this.handleClickOutside);
    count = 0;
  }
  arrowKeyNavigation = async (event) => {
    if (
      [13].indexOf(event.keyCode) > -1 &&
      this.refs.selectRef.select.state.focusedOption
    ) {
      const isExistingOption = this.props.columnOptions.options.includes(this.refs.selectRef.select.state.focusedOption.value);
      if (this.props.colDef.cellRendererParams.columnOptions.allow_free_text === true || isExistingOption) {
        this.handleChange({ value: this.refs.selectRef.select.state.focusedOption.value, label: this.refs.selectRef.select.state.focusedOption.value }, false);
      } else {
        window.appStore.notificationStore.showNotification(
          this.props.colDef.headerName +
            " does not contain the value from the dropdown list.",
          "error"
        );
      }
    } else if (
      ([13].indexOf(event.keyCode) > -1 || event.keyCode === 9) &&
      !this.refs.selectRef.select.state.focusedOption &&
      this.inputValue !== ""
    ) {
      const isExistingOption = this.props.columnOptions.options.includes(this.inputValue);
      if (this.props.columnOptions.allow_free_text === true || isExistingOption) {
        let inputOption = {
          value: this.inputValue,
          label: this.inputValue,
          color: COLORS.PRIMARY_COLOR,
          background: "transparent",
        };
        this.handleChange(inputOption);
      } else {
        window.appStore.notificationStore.showNotification(
          this.props.colDef.headerName +
            " does not contain the value from the dropdown list.",
          "error"
        );
      }
    }
  };

  focus() {
    window.setTimeout(() => {
      if(this.refs.selectRef)
        this.refs.selectRef.focus();
      document.addEventListener("mousedown", this.handleClickOutside);
      if (this.refs.container &&
        window.innerHeight - this.refs.container.getBoundingClientRect().top <
        this.refs.container.getBoundingClientRect().height + (this.props.colDef.store.isSubsheet ? 160 : 40) 
      ) {
        this.setState({
          top: null,
          bottom: 1,
        });
      } else {
        this.setState({
          top: this.props.node.rowHeight,
          bottom: null,
        });
      }
    });
  }
  getValue() {
    return this.state.selectedOption?.label;
  }

  isPopup() {
    return true;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.stopEditing(true);
    }
  }

  selectStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: this.props.colDef.width,
      margin: 8,
    }),
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    }),
    valueContainer: (provided) => ({
      ...provided,
      cursor: "text",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const background =
        data.background === "transparent" || Array.isArray(data.background)
          ? chroma("grey")
          : chroma(data.background);
      return {
        ...styles,
        display: "flex",
        alignItems: "center",
        backgroundColor: isDisabled
          ? null
          : isSelected || isFocused
          ? background.alpha(0.1).css()
          : null,
        color: isDisabled
          ? COLORS.DISABLED_MENU_OPTION
          : isSelected
          ? chroma.contrast(background, COLORS.PRIMARY_COLOR) > 2
            ? COLORS.PRIMARY_COLOR
            : COLORS.SECONDARY_COLOR
          : data.background,
        cursor: isDisabled ? "not-allowed" : "default",
  
        ":active": {
          ...styles[":active"],
          backgroundColor:
            !isDisabled &&
            (isSelected ? data.background : background.alpha(0.3).css()),
        },
      };
    },
  };

  render() {
    let rootStyle = {
      background: COLORS.PRIMARY_COLOR,
      display: "inline-block",
      visibility: this.state.top || this.state.bottom ? "visible" : "hidden",
      position: "absolute",
      top: this.state.top,
      bottom: this.state.bottom,
      boxShadow: "4px 4px 10px #aaa",
    };

    const { selectedOption } = this.state;
    return (
      <div ref={this.setWrapperRef}>
        <div ref="container" style={rootStyle}>
          <Select
            ref="selectRef"
            defaultInputValue={this.props.charPress ? this.props.charPress : ""}
            value={selectedOption}
            onChange={(selectedOption) =>
              this.handleChange(selectedOption, true)
            }
            onInputChange={this.handleInputChange}
            options={this.state.options}
            autoFocus={true}
            menuIsOpen={true}
            backspaceRemovesValue={false}
            components={{
              DropdownIndicator: null,
              IndicatorSeparator: null,
            }}
            formatOptionLabel={(props) => (
              <OptionFormatter
                {...props}
                rowHeight={this.props.node.rowHeight} 
                inputValue={this.inputValue}
                columnWidth={this.props.colDef.width}
              />
            )}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            placeholder="Find an option.."
            styles={this.selectStyles}
            tabSelectsValue={false}
            maxMenuHeight="25vh"
          />
        </div>
      </div>
    );
  }
}

const OverflowChip = ({ label, textStyle, background, color, tooltipProps }) => {
  const textElementRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const element = textElementRef.current;
    if (element) {
      const isTruncated = element.scrollWidth > element.clientWidth;
      setIsOverflowing(isTruncated);
    }
  }, [label, textStyle.maxWidth]);

  return (
    <Tooltip
      title={label}
      disableHoverListener={!isOverflowing}
      placement="bottom"
      {...tooltipProps}
    >
      <Chip
        label={
          <div ref={textElementRef} style={textStyle}>
            {label}
          </div>
        }
        style={{
          backgroundColor: background,
          color: color,
          maxWidth: "100%"
        }}
        size="small"
      />
    </Tooltip>
  );
};

export const OptionFormatter = ({
  value,
  label,
  color,
  background,
  rowHeight,
  onClick,
  inputValue,
  columnWidth = 180,
}) => {
  const textStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: columnWidth ? `${columnWidth - 20}px` : "100%",
    display: "block"
  };

  const addOptionTextStyle = {
    ...textStyle,
    maxWidth: columnWidth ? `${columnWidth - 120}px` : "100%",
  };

  const tooltipPopperProps = {
    className: "rowDetailTooltip",
    style: { zIndex: 99999, pointerEvents: 'none' }
  };

  const isAddOption =
    label &&
    typeof label === "string" &&
    label.startsWith("Add option") &&
    inputValue !== "";

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      {isAddOption ? (
        <React.Fragment>
          <div style={{ color: "black", whiteSpace: "nowrap", marginRight: 4 }}>
            Add option:
          </div>
          <OverflowChip 
             label={inputValue}
             textStyle={addOptionTextStyle}
             background={background}
             color={color}
             tooltipProps={{ PopperProps: tooltipPopperProps }}
          />
        </React.Fragment>
      ) : (
        <OverflowChip 
           label={label}
           textStyle={textStyle}
           background={background}
           color={color}
           tooltipProps={{ PopperProps: tooltipPopperProps }}
        />
      )}
    </div>
  );
};